<template>
	<div
		class="qrContainer"
		:style="{ background: appSpecficData[appType].primaryColor }"
	>
		<div class="boldText">Scan & Download the app now</div>
		<div class="qrWrapper">
			<div class="appNameContainer">
				<img class="appImage" :src="appSpecficData[appType].logoUrl" />
				<div
					:style="{
						color: appSpecficData[appType].appTitleColor
					}"
					class="appName"
				>
					{{ appSpecficData[appType].appTitle }}
				</div>
			</div>
			<div class="subText">
				Get
				<span
					:style="{
						color: appSpecficData[appType].secondaryColor
					}"
					class="Fw600"
					>₹10</span
				>
				in wallet on sign up & Win Big
			</div>
			<qrcode-vue :value="link" :size="150" level="H" />
			<div class="subText">Contact No - {{ phoneNo }}</div>
			<div class="winTextOuter">
				<div
					:style="{
						color: appSpecficData[appType].secondaryColor
					}"
					style="font-size: 72px; font-weight: 700"
				>
					5
				</div>
				<div class="winTextInner">
					<div
						:style="{ color: appSpecficData[appType].primaryColor }"
						class="Fw600"
						style="font-size: 18px;"
					>
						Play & Win
					</div>
					<div
						:style="{
							color: appSpecficData[appType].secondaryColor
						}"
						class="Fw600"
						style="font-size: 30px;"
					>
						CRORES
					</div>
				</div>
			</div>
			<div
				:style="{ color: appSpecficData[appType].appTitleColor }"
				style="font-weight: 600"
			>
				{{ appSpecficData[appType].actionText }}
			</div>
		</div>
		<div class="disclaimer">
			*This game involves an element of financial risk and<br />
			may be addictive. <br />
			Please play responsibly and at your own risk
		</div>
	</div>
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
	name: "QRCodeViewer",
	components: {
		QrcodeVue
	},
	props: ["link", "phoneNo", "appType"],
	data: () => ({
		appSpecficData: {
			JEET11: {
				primaryColor: "#28619d",
				secondaryColor: "#ff911a",
				appTitle: "JEET11",
				appTitleColor: "#003a79",
				actionText: "Visit www.jeet11.com",
				logoUrl:
					"https://cdn.jeet11.com/images/manifest/maskable_icon_x192.png"
			},
			RUMMY: {
				primaryColor: "#6d1818",
				secondaryColor: "#BD882C",
				// appTitle: "JEET11 Rummy",
				appTitleColor: "#410e0e",
				actionText: "Visit www.jeet11.com/download-rummy",
				logoUrl:
					"https://cdn.jeet11.com/images/appAssets/rummy/RummyLogoNew.png"
			}
		}
	})
};
</script>
<style scoped>
.qrContainer {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 18px;
	width: fit-content;
	margin: auto;
	white-space: nowrap;
	margin-bottom: 20px;
}
.boldText {
	font-size: 18px;
	font-weight: 600;
	color: white;
	margin-bottom: 12px;
}
.qrWrapper {
	background: white;
	border-radius: 16px;
	padding: 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.appNameContainer {
	display: flex;
	align-items: center;
}
.appName {
	font-size: 48px;
	font-weight: 600;
}
.appImage {
	width: 84px;
	height: 84px;
}
.subText {
	color: #000;
	margin-bottom: 12px;
}
.winTextOuter {
	display: flex;
	align-items: center;
	line-height: 1;
}
.winTextInner {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 8px;
}
.disclaimer {
	color: white;
	font-size: 10px;
	text-align: center;
	width: 80%;
}
</style>
